import React, { useMemo, useState } from "react";
import Column from "@amzn/meridian/column";
import { useDeviceLayout } from "../../common/context/DeviceLayoutContext";
import Alert from "@amzn/meridian/alert";
import { getRegion } from "../../util/Util";

const SettingsPermissionsWarning = ({ width, banner = {} }) => {
  const { spacingInset_shorthand2 } = useDeviceLayout();
  const [isWarningsBanner, setWarningsBanner] = useState(true);
  const region = useMemo(() => {
    const reg = getRegion();
    return reg ? reg.toUpperCase() : null;
  }, []);
  return region && banner[region] && isWarningsBanner ? (
    <Column
      spacingInset={spacingInset_shorthand2}
      width={width ? width : "85%"}
      className="alert-border"
      spacing={"none"}
    >
      <Alert
        type={"warning"}
        size={"large"}
        onClose={() => {
          setWarningsBanner(false);
        }}
      >
        {banner[region]}
      </Alert>
    </Column>
  ) : (
    ""
  );
};

export default SettingsPermissionsWarning;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/SettingsPermissionsWarning.js